<!--  -->
<template>
  <div class="title_box">
    <div class="title">{{ title }}</div>
    <div class="desc" v-show="desc">—— {{ desc }} ——</div>
  </div>
</template>

<script>
export default {
  name: "titleBox",
  data() {
    return {};
  },
  props: ["title", "desc"],
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.title_box {
  height: 250px;
  padding-top: 120px;
  box-sizing: border-box;
  background-color: #fff;
  text-align: center;
  font-weight: 500;

  .title {
    font-size: 30px;
    color: $theme;
    margin-bottom: 8px;
  }
  .desc {
    color: rgb(169, 169, 169);
    font-size: 14px;
  }
}

@include respond-md {
  .title_box {
    height: 200px;
    padding-top: 88px;

    .title {
      font-size: 24px;
      padding: 0 16px;
    }

    .desc {
      font-size: 13px;
      padding: 0 16px;
    }
  }
}
</style>